import React from "react"
import { Box, keyframes, Typography } from "@mui/material"


const firstDotStyles = {
	animation: `${keyframes({
		"0%": { opacity: 1 },
		"65%": { opacity: 1 },
		"66%": { opacity: 0 },
		"100%": { opacity: 0 }
	})} 2s linear infinite`
}

const secondDotStyles = {
	animation: `${keyframes({
		"0%": { opacity: 0 },
		"21%": { opacity: 0 },
		"22%": { opacity: 1 },
		"65%": { opacity: 1 },
		"66%": { opacity: 0 },
		"100%": { opacity: 0 }
	})} 2s linear infinite`
}

const thirdDotStyles = {
	animation: `${keyframes({
		"0%": { opacity: 0 },
		"43%": { opacity: 0 },
		"44%": { opacity: 1 },
		"65%": { opacity: 1 },
		"66%": { opacity: 0 },
		"100%": { opacity: 0 }
	})} 2s linear infinite`
}

export default function LoadingText({ label, sx = {}, variant = 'body1' }) {
	return <Typography variant={variant} sx={{ color: 'text.disabled', ...sx }}>
		{label}
		<Box component="span" sx={firstDotStyles}>.</Box>
		<Box component="span" sx={secondDotStyles}>.</Box>
		<Box component="span" sx={thirdDotStyles}>.</Box>
	</Typography>
}